import { render, staticRenderFns } from "./shareOrder4.vue?vue&type=template&id=28895801&scoped=true&"
import script from "./shareOrder4.vue?vue&type=script&lang=js&"
export * from "./shareOrder4.vue?vue&type=script&lang=js&"
import style0 from "./shareOrder4.vue?vue&type=style&index=0&id=28895801&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28895801",
  null
  
)

export default component.exports